import React from "react";
import { Button, Modal } from "react-bootstrap";
import * as htmlToImage from "html-to-image";
import Image from "next/image";
import { gtmCall } from "lib/google-tag-manager";
import { MdCall } from "react-icons/md";

const OrderDownloadPopup = ({ show, onHide, jobReference, workshop }) => {
  const handleDownload = () => {
    const node = document.getElementById("bee-page-container-id");
    htmlToImage
      .toJpeg(node, {
        height: node.scrollHeight,
        // scrollY: -window.scrollY
      })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = "order-details.png";
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="order-download-popup-modal"
    >
      <Modal.Body className="order-download-popup">
        <p>Order Details</p>
        <img
          alt="OpenBonnet_logo"
          className="bee-center bee-fixedwidth"
          src="/assets/header/Logo12.webp"
          style={{ maxWidth: "256px" }}
        />
        <div className="bee-page-container" id="bee-page-container-id">
          <div className="bee-row bee-row-1">
            <div className="bee-row-content">
              <div className="bee-col bee-col-1 bee-col-w12">
                <div className="bee-block bee-block-3 bee-heading">
                  <h1 className="bee-heading-style">
                    <span className="tinyMce-placeholder">
                      Order Confirmation Tag
                    </span>
                  </h1>
                </div>
                {workshop ? (
                  <div className="bee-block bee-block-5 bee-text">
                    <div
                      className="bee-text-content"
                      style={{
                        lineHeight: "120%",
                        fontSize: "12px",
                        fontFamily: "inherit",
                        color: "#ffffff",
                      }}
                    >
                      <p
                        style={{
                          fontSize: "14px",
                          lineHeight: "16px",
                          textAlign: "center",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "16px",
                            lineHeight: "19px",
                            color: "#fff",
                          }}
                        >
                          <strong>
                            <u>Workshop:</u>
                          </strong>{" "}
                          {workshop}
                        </span>
                      </p>
                    </div>
                  </div>
                ) : null}
                <p
                  style={{
                    color: "#fff",
                    textAlign: "center",
                    marginTop: "-10px",
                  }}
                >
                  Job Reference: {jobReference}
                </p>
                <div className="bee-block bee-block-6 bee-image qr-code-download">
                  <img
                    alt="OB-download"
                    className="bee-center bee-fixedwidth"
                    src="/assets/b6b0ff4a-0d86-4b90-a19b-8d7104df8f4c.webp"
                    style={{ maxWidth: "256px" }}
                  />
                </div>
                <div className="bee-block bee-block-8 bee-paragraph">
                  <span style={{}}>
                    Show this Tag at Workshop to avail service for your car.
                  </span>
                </div>
                <div className="d-flex justify-content-center">
                  <Image
                    src="/assets/dashboard/order-qr-design.webp"
                    width="400"
                    height="50"
                  />
                </div>
                <div className="bee-block bee-block-8 bee-paragraph d-flex justify-content-center">
                  <div className="bee-block bee-block-2 bee-button">
                    <a
                      onClick={() => gtmCall()}
                      href="tel:+9718002274357"
                      target="_blank"
                      data-title="8002274357"
                      className="call-button-download-popup"
                    >
                      <MdCall color="#fff" size="30" /> 800 CAR HELP (800 227
                      4357)
                    </a>
                    <a
                      target="_blank"
                      href="/"
                      className="call-button-download-popup"
                    >
                      www.openbonnet.com
                    </a>
                  </div>
                  <div className="bee-block bee-block-2 bee-button  bee-divider">
                    <div className="bee-col bee-col-2 bee-col-w6">
                      <div className="bee-block bee-block-1 bee-image">
                        <img
                          alt="I'm an image"
                          className="bee-center bee-fixedwidth"
                          src="/assets/dashboard/openbonnet-qr.jpeg"
                          style={{ maxWidth: "100px" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between ">
        <Button variant="primary" onClick={handleDownload}>
          {/* <FaDownload style={{ fontSize: "14px", marginRight: "10px" }} /> */}
          Download
        </Button>
        <Button variant="primary" onClick={onHide}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OrderDownloadPopup;
